import React, { useMemo } from 'react'
import SonarcloudMappingFormV2 from './SonarcloudMappingFormV2';
import SonarcloudCredentialsForm from './SonarcloudCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { map } from 'lodash';
import {CellRenderers, columnRenderArrayData} from "utils/tableUtils";

export default function SonarcloudConfigListing(props) {


    const columns = useMemo(() => {
        const baseColumns = [
            {
                title: "Component",
                render: (record) => {
                    return columnRenderArrayData(record["componentDisplayName"]);
                },
                width: 200,
            },
        ];

        const branchColumn = {
            title: "Branch",
            dataIndex: "componentNameWithBranch",
            render: (componentNameWithBranch) => {
                if (componentNameWithBranch) {
                    return columnRenderArrayData(getBranchValues(componentNameWithBranch, true).join());
                } else {
                    return CellRenderers.VALUE_OR_NA();
                }
            },
            width: 200,
        };

        return [...baseColumns, branchColumn];
    }, []);


    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={SonarcloudMappingFormV2}
            CredentialsForm={SonarcloudCredentialsForm}
            extraColumns={columns}
        />
    )
}

export const getBranchValues= (componentNameWithBranch, displayNA = false) => map(Object.keys(JSON.parse(componentNameWithBranch)), (item) => {
    const emptyDisplay = displayNA ? CellRenderers.VALUE_OR_NA() : undefined;
    const branch = JSON.parse(componentNameWithBranch)[item]
    return branch ? branch : emptyDisplay
});